import _ from 'lodash';
import * as types from './types';
import { toastType, createToast } from 'Common/ToastHelper';
import { loading } from 'State/actions';
import { MBENotificationLetterHistoryTypes } from 'Common/Constants/Enumeration/MBENotificationLetterTypes.js';

export const fetchInitialData = () => {
  return async (dispatch, getState, MPWWebApi) => {
    dispatch(loading(types.MBE_NOTIFICATION_LETTERS_LOADING, true));

    try {
      const responseCalendars = await MPWWebApi.getGeneric('SchoolCalendar');

      const data = {
        LetterTypes: [
          MBENotificationLetterHistoryTypes.MBENotification,
          MBENotificationLetterHistoryTypes.CEPTransferNotification,
        ],
      };
      const responseBadEmails = await MPWWebApi.postGenericInsertUpdate(
        'Letter/GetBadEmailLetterHistory',
        data
      );

      dispatch({
        type: types.MBE_NOTIFICATION_LETTERS_GET_CALENDARS,
        payload: _.get(responseCalendars, 'data.Data', []),
      });

      dispatch({
        type: types.MBE_NOTIFICATION_LETTERS_GET_BAD_EMAILS,
        payload: _.get(responseBadEmails, 'data.Data', []),
      });
    } catch (error) {
      dispatch({
        type: types.MBE_NOTIFICATION_LETTERS_ERROR,
        payload: error.response,
      });
    }

    dispatch(loading(types.MBE_NOTIFICATION_LETTERS_LOADING, false));
  };
};

export const toggleCalendar = (checked, id) => {
  return {
    type: types.MBE_NOTIFICATION_LETTERS_CALENDAR_TOGGLE,
    payload: { checked: checked, id: id },
  };
};

export const toggleCalendarAll = checked => {
  return {
    type: types.MBE_NOTIFICATION_LETTERS_CALENDAR_TOGGLE_ALL,
    payload: checked,
  };
};

export const processMBE = data => {
  return async (dispatch, getState, MPWWebApi) => {
    const selectedCalendars = _.get(data, 'SelectedCalendars', []);
    const isPrintBadEmails = _.get(data, 'IsPrintBadEmails', false);

    if (selectedCalendars.length === 0 && isPrintBadEmails === false) {
      return createToast(
        toastType.error,
        'Error',
        'Please select one or more calendars to continue!',
        true
      );
    }

    try {
      MPWWebApi.postGenericInsertUpdate(
        'Letter/GetMBENotificationLetters',
        data
      );

      const badEmails = _.get(data, 'BadEmailLetterHistoryIds', []);

      dispatch({
        type: types.MBE_NOTIFICATION_LETTERS_PROCESS_LETTERS,
        payload: badEmails,
      });
    } catch (error) {
      dispatch({
        type: types.MBE_NOTIFICATION_LETTERS_ERROR,
        payload: error.response,
      });
    }
  };
};

export const processCEPTransfer = data => {
  return (dispatch, getState, MPWWebApi) => {
    try {
      MPWWebApi.postGenericInsertUpdate(
        'Letter/GetCEPTransferNotificationLetters',
        data
      );

      const badEmails = _.get(data, 'BadEmailLetterHistoryIds', []);

      dispatch({
        type: types.MBE_NOTIFICATION_LETTERS_PROCESS_LETTERS,
        payload: badEmails,
      });

      dispatch({
        type: types.MBE_NOTIFICATION_LETTERS_PROCESS_LETTERS,
        payload: badEmails,
      });
    } catch (error) {
      dispatch({
        type: types.MBE_NOTIFICATION_LETTERS_ERROR,
        payload: error.response,
      });
    }
  };
};

export const clearBadEmails = data => {
  return async (dispatch, getState, MPWWebApi) => {
    MPWWebApi.postGenericInsertUpdate(
      'Letter/WriteLetterHistoryNotifiedUserId',
      data
    );

    try {
      dispatch({
        type: types.MBE_NOTIFICATION_LETTERS_CLEAR_BAD_EMAILS,
        payload: [...data.letterHistoryIds],
      });
    } catch (error) {
      dispatch({
        type: types.MBE_NOTIFICATION_LETTERS_ERROR,
        payload: error.response,
      });
    }
  };
};



// WEBPACK FOOTER //
// ./src/pages/mbenotification/state/letters/actions.js